/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { mcpMetadataExport } from "../funcs/mcpMetadataExport.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { McpExport } from "../models/components/mcpexport.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  ExportMcpMetadataRequest,
  ExportMcpMetadataSecurity,
} from "../models/operations/exportmcpmetadata.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type ExportMcpMetadataMutationVariables = {
  request: ExportMcpMetadataRequest;
  security?: ExportMcpMetadataSecurity | undefined;
  options?: RequestOptions;
};

export type ExportMcpMetadataMutationData = McpExport;

export type ExportMcpMetadataMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * exportMcpMetadata mcpMetadata
 *
 * @remarks
 * Export MCP server details as JSON for documentation and integration purposes. Exactly one of mcp_slug or mcp_server_id must be provided.
 */
export function useExportMcpMetadataMutation(
  options?: MutationHookOptions<
    ExportMcpMetadataMutationData,
    ExportMcpMetadataMutationError,
    ExportMcpMetadataMutationVariables
  >,
): UseMutationResult<
  ExportMcpMetadataMutationData,
  ExportMcpMetadataMutationError,
  ExportMcpMetadataMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildExportMcpMetadataMutation(client, options),
    ...options,
  });
}

export function mutationKeyExportMcpMetadata(): MutationKey {
  return ["@gram/client", "mcpMetadata", "export"];
}

export function buildExportMcpMetadataMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: ExportMcpMetadataMutationVariables,
  ) => Promise<ExportMcpMetadataMutationData>;
} {
  return {
    mutationKey: mutationKeyExportMcpMetadata(),
    mutationFn: function exportMcpMetadataMutationFn({
      request,
      security,
      options,
    }): Promise<ExportMcpMetadataMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(mcpMetadataExport(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
